import { render, staticRenderFns } from "./CreateSalesOrderModal.vue?vue&type=template&id=b6adb54a&scoped=true&"
import script from "./CreateSalesOrderModal.vue?vue&type=script&lang=ts&"
export * from "./CreateSalesOrderModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSalesOrderModal.vue?vue&type=style&index=0&id=b6adb54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6adb54a",
  null
  
)

export default component.exports